
/** 認証 */
import AdminAuthentication from './authentication'
/** 契約者 */
import AdminContractor from './contractor'
import ConnectPaidContactor from './contractors/connect_paid'
import ConnectPaidTenant from './contractors/tenants/connect_paid'
/** テナント */
import AdminTenant from './tenant'
/** テナントへのお知らせ */
import AdminNotification from './notification'
/**　トピック表示 */
import AdminTopic from './topic' 
/** DXEへのお知らせ */
import AdminDxeNotification from './dxe_notification'
/** ユーザー */
import AdminUser from './user'
/** テナントユーザー */
import AdminTenantUser from './tenant_user'
/** 排出事業者 */
import AdminMasterEmission from './masters/emission'
/**　排出事業者一覧 CSV出力予約 */
import AdminMasterEmissionOutputReservation from './masters/emissions/output_reservation'
/** 収運運搬業者 */
import AdminMasterTransport from './masters/transport'
/** 処分業者 */
import AdminMasterDisposer from './masters/disposer'
/** 政令市 */
import AdminMasterOrdinanceCity from './masters/ordinance_city'
/** テナント(名称検索用) */
import AdminMasterTenant from './masters/tenant'
/** 運搬ルート */
import AdminMasterTransportRoute from './masters/transport_route'
/** システム設定 */
import AdminSystemSetting from './system_setting'
/** 請求データ */
import AdminInvoice from './invoice'
/** マニフェスト登録件数 */
import AdminManifestReport from './manifest_report'
/** 排出事業者CSV入出力 */
import AdminSettingEmission from './settings/emission'
/** 収集運搬業者CSV入出力 */
import AdminSettingTransport from './settings/transport'
/** 処分業者CSV入出力 */
import AdminSettingDisposer from './settings/disposer'
/** EDI申請取込 */
import AdminSettingEdiRequest from './settings/edi_request'
/** CSV取込*/
import AdminCsvImportTask from './csv_import_task'
/** 出力ファイル */
import AdminOutputFile from './output_file'
/** EDI申込み管理 */
import AdminEdiRequest from './edi_request'
/** EDI申込み管理（排出事業者選択ダイアログ） */
import AdminEdiRequestEmissionSelect from './edi_request_emission_select'

const AdminModules = {
    modules: {
      AdminAuthentication,
      AdminContractor,
      AdminTenant,
      AdminNotification,
      AdminTopic,
      AdminDxeNotification,
      AdminUser,
      AdminTenantUser,
      AdminMasterEmission,
      AdminMasterEmissionOutputReservation,
      AdminMasterTransport,
      AdminMasterDisposer,
      AdminMasterOrdinanceCity,
      AdminMasterTenant,
      AdminMasterTransportRoute,
      ConnectPaidContactor,
      ConnectPaidTenant,
      AdminSystemSetting,
      AdminInvoice,
      AdminManifestReport,
      AdminSettingEmission,
      AdminSettingTransport,
      AdminSettingDisposer,
      AdminSettingEdiRequest,
      AdminCsvImportTask,
      AdminOutputFile,
      AdminEdiRequest,
      AdminEdiRequestEmissionSelect,
    }
}
export default AdminModules.modules
